import axios from "axios";
import { logout } from "helper/extension";

const apiBaseUrl = process.env.REACT_APP_API_URL;
const apiBaseReviewUrl = process.env.REACT_SUPABASE_API_URL;
const pathName = window.location.pathname;
const instance = pathName.includes('review') ? axios.create({ baseURL: apiBaseReviewUrl }) : axios.create({ baseURL: apiBaseUrl });


function responseHelper(response) {
  if (response?.status === 401) {
    logout(true);
  }
  if (response?.status === 200 || response?.status === 201) {
    return response.data;
  }
  throw new Error(response?.data?.message || "Unknown error occurred");
}

function errorHelper(error) {

  if (error?.status === 401) {
    logout(true);
  }

  let errorMessage = "An unknown error occurred.";
  if (error?.response?.data) {
    const message = error.response.data;

    if (message?.code !== undefined || message?.statusCode !== undefined) {
      const errorMessages = message.message;

      if (Array.isArray(errorMessages)) {
        // Join array elements into a single error message
        errorMessage = errorMessages.join(", ");
      } else if (typeof errorMessages === "string") {
        errorMessage = errorMessages;
      } else {
        errorMessage = "An unknown error occurred with code.";
      }
    } else if (typeof message === "string") {
      errorMessage = message; // Assign directly if it's a string
    } else {
      errorMessage = JSON.stringify(message); // Fallback for unexpected object
    }
  }

  // Return the error message as a rejected Promise
  return Promise.reject(new Error(errorMessage));
}


// function errorHelper(error) {
//   if (error?.status === 401) {
//     logout(true);
//   }
//   let errorMessage = "Unknown error occurred";

//   if (error?.response?.data) {
//     const message = error.response.data;
//     if (message?.code !== undefined || message?.statusCode !== undefined) {
//       const errorMessages = message.message;
//       if (Array.isArray(errorMessages)) {
//         errorMessages.forEach((errorMessage) => {
//           console.warn(errorMessage);
//         });
//         errorMessage = errorMessages.join(", ");
//       } else {
//         // console.warn(errorMessages);
//         errorMessage = errorMessages;
//       }
//     } else {
//       errorMessage = message;
//     }
//   }

//   return Promise.reject(new Error(errorMessage));
// }

instance.interceptors.request.use(
  function configHeader(config) {
    const currentUser = JSON.parse(localStorage.getItem("userData")); 
    let token = currentUser?.result?.token
    if (token && !config?.headers?.Authorization) {
      config.headers["Authorization"] = `Bearer ${token}`; // Attach token
    }
    config.headers = { ...config.headers };
    return config;
  },
  function configError(error) {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(responseHelper, errorHelper);

export default instance;
